const ReactDOM = require('react-dom')
const React = require('react')
const Cursor = require('./src/components/Cursor').default
const ImageLiquidHoverFX = require('./src/components/ImageLiquidHoverFX').default

export function replaceHydrateFunction() {
    return (element, container, callback) => {
        ReactDOM.render(element, container, callback)
    }
}

export const wrapRootElement = ({ element }) => (
  <>
    {element}
    <Cursor />
    <ImageLiquidHoverFX nonLinkOnly={true} />
  </>
)